import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TopicsTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function TopicsTab() {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingTopic, setEditingTopic] = useState(null);
  const [formData, setFormData] = useState({ title: '' });

  useEffect(() => {
    fetchTopics();
  }, []);

  const fetchTopics = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/topics`);
      setTopics(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке тем: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingTopic) {
        await axios.put(`${API_URL}/api/topics/${editingTopic.id}`, formData);
      } else {
        await axios.post(`${API_URL}/api/topics`, formData);
      }
      setShowForm(false);
      setEditingTopic(null);
      setFormData({ title: '' });
      fetchTopics();
    } catch (err) {
      setError('Ошибка при сохранении темы: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleEdit = (topic) => {
    setEditingTopic(topic);
    setFormData({ title: topic.title });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту тему?')) {
      try {
        await axios.delete(`${API_URL}/api/topics/${id}`);
        fetchTopics();
      } catch (err) {
        setError('Ошибка при удалении темы: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingTopic(null);
    setFormData({ title: '' });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="topics-tab">
      <div className="tab-header">
        <h2>Управление темами</h2>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить тему
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h3>{editingTopic ? 'Редактировать тему' : 'Добавить новую тему'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="title">Название темы *</label>
              <input
                type="text"
                id="title"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                required
                maxLength={255}
                placeholder="Введите название темы"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingTopic ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {topics.length === 0 ? (
              <tr>
                <td colSpan="3" className="empty-state">
                  Нет тем. Добавьте первую тему.
                </td>
              </tr>
            ) : (
              topics.map((topic) => (
                <tr key={topic.id}>
                  <td>{topic.id}</td>
                  <td>{topic.title}</td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(topic)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(topic.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TopicsTab;

